export default __webpack_public_path__ + "static/media/QK_9916.7485aa8e.jpg";